import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchDocumentTemplateAction } from '../actions';
import { getDocumentTemplateStore } from '../selectors';
import { DocumentTemplateStore } from '../types';

export const useGetDocumentById = (
  docId: number,
  refetch?: boolean,
): ValueOf<DocumentTemplateStore> | undefined => {
  const dispatch = useDispatch();
  const template = useSelector(getDocumentTemplateStore(docId));

  useEffect(() => {
    if (refetch) {
      dispatch(fetchDocumentTemplateAction({ templateId: docId }));
    }
  }, [docId, dispatch, refetch]);

  return template;
};
